//   const USAComma = useNumberFormatter();
// formatNumber(lead?.QuotedValue);


export default function CommaConvert() {
  const countryCode = String(localStorage.getItem("countrycode") || "").trim();
  const region = String(localStorage.getItem("region") || "")
    .trim()
    .toUpperCase();
  const isUsLocale = countryCode === "+1" || countryCode === "1" || region === "US" || region === "USA";
  const isInLocale = countryCode === "+91" || countryCode === "91" || region === "IN" || region === "INDIA";
  const locale = isInLocale ? "en-IN" : "en-US";

  /**
   * @param {number|string} num
   * @param {{ decimals?: boolean }} [options] - when decimals:true, keep up to 2 decimal places (no integer Math.round)
   */
  return (num, options = {}) => {
    if (num === undefined || num === null) return "";
    const value = Number(num);
    if (isNaN(value)) return "";

    if (options?.decimals) {
      // Preserve fractional currency (e.g. Tax 10648.8); avoid float noise beyond 2 places
      const withDecimals = Math.round((value + Number.EPSILON) * 100) / 100;
      return withDecimals.toLocaleString(locale, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    }

    if (isUsLocale || !isInLocale) {
      return Math.round(value).toLocaleString("en-US");
    }

    return Math.round(value).toLocaleString("en-IN");
  };
}
